import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";

const CARDS = [
  {
    img: "/assets/feat_connections.jpg",
    title: "Real connections only.",
    desc: "No games, no ghosts — people who show up.",
  },
  {
    img: "/assets/feat_verified.jpg",
    title: "Selfie-checked photos.",
    desc: "A live selfie matched to the pictures on the profile.",
  },
  {
    img: "/assets/feat_safety.jpg",
    title: "Safety, one tap away.",
    desc: "Block or report anyone, whenever you need to.",
  },
];

const FeatureCard = ({ card, index }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-28, 28]);

  const tilt = index === 1 ? "3deg" : index === 2 ? "6deg" : "-6deg";

  return (
    <Reveal delay={0.05 + index * 0.1} className="h-full">
      <div className="feature-card-stage h-full">
        <div
          ref={ref}
          style={{ "--tilt": tilt }}
          className="feature-card-tilt group flex h-full flex-col overflow-hidden rounded-[2.5rem] bg-[#FBF8F3] shadow-[0_26px_50px_-28px_rgba(140,110,60,0.35)] ring-1 ring-[#C4A36A]/35"
          data-testid={`feature-card-${index + 1}`}
        >
          <div className="relative aspect-square overflow-hidden">
            <motion.img
              src={card.img}
              alt={card.title}
              loading="lazy"
              style={{ y }}
              className="absolute left-0 top-[-12%] h-[124%] w-full object-cover transition-transform duration-700 ease-out [@media(hover:hover)_and_(pointer:fine)]:group-hover:scale-[1.03]"
              data-testid={`feature-card-${index + 1}-image`}
            />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 z-[1] h-24 bg-gradient-to-t from-[#FBF8F3] to-transparent" aria-hidden="true" />
          </div>
          <div className="flex flex-1 flex-col px-8 pb-10 pt-2">
            <h3 className="font-serif text-3xl font-bold leading-tight tracking-tight text-[#7A5A14]">{card.title}</h3>
            <p className="mt-3 text-base font-medium leading-relaxed text-[#7E5C28]">{card.desc}</p>
          </div>
        </div>
      </div>
    </Reveal>
  );
};

export const FeatureCards = () => (
  <section id="features" className="bg-[#F7F3EA] px-6 py-24 md:px-12 md:py-32" data-testid="feature-cards-section">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <p className="mb-10 text-center font-serif text-2xl italic tracking-tight text-[#7A5A14] sm:text-3xl" data-testid="feature-cards-richmond">
          Starting in Richmond.
        </p>
      </Reveal>
      <div className="grid gap-6 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <FeatureCard key={c.title} card={c} index={i} />
        ))}
      </div>
    </div>
  </section>
);
